export const addProtocolToWebsiteUrl = (website: string) =>
  (!/^https?:\/\//i.test(website) && `https://${website}`) || website
